import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useState } from "react";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { useResizeObserver } from "./auth-service-tools544.js";
import { ScrollAreaScrollbarVisible } from "./auth-service-tools548.js";
import { useDebouncedCallback } from "./auth-service-tools552.js";
const ScrollAreaScrollbarAuto = /*#__PURE__*/forwardRef((props, ref) => {
  const context = useScrollAreaContext();
  const {
    forceMount,
    ...scrollbarProps
  } = props;
  const [visible, setVisible] = useState(false);
  const isHorizontal = props.orientation === "horizontal";
  const handleResize = useDebouncedCallback(() => {
    if (context.viewport) {
      const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
      const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
      setVisible(isHorizontal ? isOverflowX : isOverflowY);
    }
  }, 10);
  useResizeObserver(context.viewport, handleResize);
  useResizeObserver(context.content, handleResize);

  if (forceMount || visible) {
    return /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarVisible, {
      "data-state": visible ? "visible" : "hidden",
      ...scrollbarProps,
      ref
    });
  }

  return null;
});
ScrollAreaScrollbarAuto.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
export { ScrollAreaScrollbarAuto };